/* Shorthand */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./components/table/table"));


//////////////////
// WEBPACK FOOTER
// ./~/primeng/table.js
// module id = 422
// module chunks = 6